module.exports = __webpack_public_path__ + "static/weronikawork7-960edd52d6d8cd2378db95fab8fd7451.png";